import { useQuery } from '@tanstack/react-query';
import { getCouponService } from '../../../domains/coupon';

const isResultOk = (res: any) => res?.result_code === '200' || res?.resultCode === 200;

interface Options {
  active?: boolean;
  limit?: number;
  offset?: number;
  start_date?: string;
  end_date?: string;
}

export const usePharmacyCouponHistory = (
  brn: string | null | undefined,
  options: Options = {}
) => {
  return useQuery({
    queryKey: ['pharmacy-coupon-history', brn, options],
    enabled: !!brn,
    queryFn: async () => {
      const res = await getCouponService().getPharmacyHistory(brn, options);
      if (!isResultOk(res)) return { items: [], total: 0, summary: {} };
      const items = res?.data?.items ?? res?.data?.list ?? [];
      return {
        items: Array.isArray(items) ? items : [],
        total: (res?.data?.total ?? items.length) as number,
        summary: (res?.data?.summary ?? {}) as Record<string, any>,
      };
    },
  });
};
